const Login = () => import("../views/H5Promotion/NotRegistered");
const Receive = () => import("../views/H5Promotion/Registration")

const h5Routes = [
    {
        path: "/h5login",
        name: "promotion",
        meta: {
            title: "新用户专享100元出行礼包"
        },
        component: Login
    },
    {
        path: "/h5receive",
        name: "promotion1",
        meta: {
            title: "新用户专享100元出行礼包"
        },
        component: Receive
    },
    
];
export default h5Routes;
